// extracted by mini-css-extract-plugin
export default {"box":"bjeaklcv9oxgHIAXC9XV","circleBox":"ubel1cm1qIDeMwoa3P4y","circle":"QFeEsIKW6sm2xqqu4ubZ","valueBox":"lrfZ10z2NLqik8jIQIgT"};